import { CSSObject, Theme } from '@emotion/react';

const wrap = (theme: Theme): CSSObject => ({
  background: '#fff',
  borderRadius: theme.borderRadius.xl,
  width: 'calc(100% - 40px)',
  '> div': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    ...theme.typography.textStyles.bodyMd600,
  },
});

const contentsArea = (theme: Theme): CSSObject => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  ...theme.typography.textStyles.bodyMd600,
  padding: '52px 20px 16px 20px',
});

const buttonArea = (theme: Theme): CSSObject => ({
  width: '100%',
  padding: '16px 20px 16px 20px',
  boxSizing: 'border-box',
  '> button': {
    width: '100%',
    height: '48px',
    ...theme.typography.textStyles.buttonLg500,
    textAlign: 'center',
    background: theme.colors.grey800,
    borderRadius: theme.borderRadius.xl,
    color: theme.colors.white,
  },
});

export { wrap, contentsArea, buttonArea };
